import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

export const pushNotifications = {
  list: ({ params = {} }: { params?: Params } = {}) =>
    buildPath("/internal_api/push_notification_broadcasts", params),
  create: ({ params = {} }: { params?: Params } = {}) =>
    buildPath("/internal_api/push_notification_broadcasts", params),
  show: ({ id, params = {} }: { id: number; params?: Params }) =>
    buildPath(`/internal_api/push_notification_broadcasts/${id}`, params),
  update: ({ id, params = {} }: { id: number; params?: Params }) =>
    buildPath(`/internal_api/push_notification_broadcasts/${id}`, params),
  send_broadcast: ({ id }: { id: number }) =>
    buildPath(
      `/internal_api/push_notification_broadcasts/${id}/send_broadcast`,
    ),
  duplicate: ({ id }: { id: number }) =>
    buildPath(`/internal_api/push_notification_broadcasts/${id}/duplicate`),
  archive: ({ id }: { id: number }) =>
    buildPath(`/internal_api/push_notification_broadcasts/${id}/archive`),
  deleteBroadcast: ({ id }: { id: number }) =>
    buildPath(`/internal_api/push_notification_broadcasts/${id}`),
  cancelSchedule: ({ id }: { id: number }) =>
    buildPath(
      `/internal_api/push_notification_broadcasts/${id}/cancel_schedule`,
    ),
  sendTestNotification: ({
    id,
    community_member_id,
  }: {
    id: number;
    community_member_id: number;
  }) =>
    buildPath(
      `/internal_api/push_notification_broadcasts/${id}/send_test_notification`,
      { community_member_id },
    ),
  report: ({ id }: { id: number }) =>
    buildPath(
      `/internal_api/push_notification_broadcasts/${id}/analytics_report`,
    ),
  recipients: ({ id, params = {} }: { id: number; params?: Params }) =>
    buildPath(
      `/internal_api/push_notification_broadcasts/${id}/recipients`,
      params,
    ),
};
